import React from 'react';
import { FireworksAnimation } from './FireworksAnimation';
import { StyledHeroContainer } from './EndGameStyling';

export const EndGame = () => {
  return (
    <StyledHeroContainer>
      <FireworksAnimation />
    </StyledHeroContainer>
  );
}